/**
 * 按日期查询拍卖场次
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 关闭交易
// 接口地址   api/v1/auctions/auction_order_close/{order_id}
Mock.mock(/\/auctions\/auction_order_close\/\d+/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'close_reason_code': 1,
    'penalty_request': 0,
    'note': '备注信息为空'
  }
})
